<template>
  <v-row>
    <v-col cols="8">
      <div class="d-flex justify-space-between">
        <h1 class="titleSt">Componente Tipos de Pneus</h1>
        <a class="text-decoration-none">
          <v-btn class="text-white" color="grey" @click="$emit('close-modal')">Cancelar</v-btn>
          <v-btn class="text-white" color="#ff5000" @click="store" v-bind:disabled="btn_disabled">Salvar</v-btn>
        </a>
      </div>
      <div class="mainInputs">
        <v-text-field v-model="fragmentId" label="ID do componente" hide-details="auto" @keyup="onInputChange()"></v-text-field>
      </div>
      <div class="mainInputs">
        <v-text-field v-model="title" label="Título" :rules="rules" hide-details="auto" @keyup="onInputChange()"></v-text-field>
      </div>

      <div>
        <br />
        <hr />
        <h2>Eixos</h2>
        <div>
          <div v-for="item in axlesOptions" :key="item.id" class="mainInputs">
            <div class="d-flex justify-space-between align-center mb-2">
              <h3>Eixo {{ item.id }}</h3>
              <v-btn v-if="item.id != 1" color="red" size="small" @click="removeAxleItem(item.id)">
                <v-icon>mdi-delete</v-icon>
                Remover
              </v-btn>
            </div>
            <v-text-field v-model="item.fragmentAxleId" label="ID do eixo" hide-details="auto" @keyup="onInputChange()"></v-text-field>
            <v-text-field v-model="item.axle" label="Eixo" :rules="rules" hide-details="auto" @keyup="onInputChange()"></v-text-field>
          </div>
          <v-btn @click="addAxleItem" color="primary" class="mt-2">
            <v-icon>mdi-plus</v-icon>
            Adicionar eixo
          </v-btn>
        </div>
      </div>

      <div>
        <br />
        <hr />
        <h2>Marcas Pneu</h2>
        <div>
          <div v-for="item in tyreBrands" :key="item.id" class="mainInputs">
            <div class="d-flex justify-space-between align-center mb-2">
              <h3>Marca {{ item.id }}</h3>
              <v-btn v-if="item.id != 1" color="red" size="small" @click="removeTyreBrandItem(item.id)">
                <v-icon>mdi-delete</v-icon>
                Remover
              </v-btn>
            </div>
            <v-text-field v-model="item.fragmentBrandId" label="ID da marca" hide-details="auto" @keyup="onInputChange()"></v-text-field>
            <v-text-field v-model="item.brand" label="Marca do Pneu" :rules="rules" hide-details="auto" @keyup="onInputChange()"></v-text-field>
          </div>
          <v-btn @click="addTyreBrandItem" color="primary" class="mt-2">
            <v-icon>mdi-plus</v-icon>
            Adicionar marca
          </v-btn>
        </div>
      </div>

      <div>
        <br />
        <hr />
        <h2>Tamanho Pneu</h2>
        <div>
          <div v-for="item in tyreSizes" :key="item.id" class="mainInputs">
            <div class="d-flex justify-space-between align-center mb-2">
              <h3>Tamanho {{ item.id }}</h3>
              <v-btn v-if="item.id != 1" color="red" size="small" @click="removeTyreSizeItem(item.id)">
                <v-icon>mdi-delete</v-icon>
                Remover
              </v-btn>
            </div>
            <v-text-field v-model="item.fragmentSizeId" label="ID do tamanho" hide-details="auto" @keyup="onInputChange()"></v-text-field>
            <v-text-field v-model="item.size" label="Tamanho do Pneu" :rules="rules" hide-details="auto" @keyup="onInputChange()"></v-text-field>
          </div>
          <v-btn @click="addTyreSizeItem" color="primary" class="mt-2">
            <v-icon>mdi-plus</v-icon>
            Adicionar tamanho
          </v-btn>
        </div>
      </div>
    </v-col>

    <v-col cols="4">
      <custom-img-component :imageSrc="imageSrc" />
    </v-col>
  </v-row>

  <v-snackbar v-model="snackbar" :timeout="timeout">
    <v-icon class="ml-1"> mdi-information-outline </v-icon> {{ text }}
    <template v-slot:actions>
      <v-btn variant="text" @click="closeSnack"> Fechar </v-btn>
    </template>
  </v-snackbar>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import messages from "@/constants/messages";
import CustomImgComponent from "@/components/CustomImg/CustomImgComponent.vue";

@Options({
  components: {
    CustomImgComponent,
  },
})
export default class TyreTypesComponent extends Vue {
  public rules = [(value: any) => !!value || "Required.", (value: string) => (value && value.length >= 3) || "Min 3 characters"];
  public title = "";
  public fragmentId = "";
  public typeFragment = "CustomTyresFragment";
  public messages: any = {};
  public isLoadingTable = true;
  public needleSearch: any;
  public snackbar = false;
  public text = "";
  public timeout = 10000;
  public btn_disabled = true;
  public generatedJson: any;
  public form: any;
  // public imageSrc = require("@/assets/CustomComponentsImgExamples/TyreTypes.png");

  // Eixos
  public axlesOptions: Array<{
    id: number;
    axle: string;
    fragmentAxleId: string;
  }> = [
    {
      id: 1,
      axle: "",
      fragmentAxleId: "",
    },
  ];
  public nextAxleId = 2;

  // Marcas de Pneu
  public tyreBrands: Array<{
    id: number;
    brand: string;
    fragmentBrandId: string;
  }> = [
    {
      id: 1,
      brand: "",
      fragmentBrandId: "",
    },
  ];
  public nextTyreBrandId = 2;

  // Tamanhos de Pneu
  public tyreSizes: Array<{
    id: number;
    size: string;
    fragmentSizeId: string;
  }> = [
    {
      id: 1,
      size: "",
      fragmentSizeId: "",
    },
  ];
  public nextTyreSizeId = 2;

  mounted(): void {
    this.messages = messages;
    this.$emit("mounted", this);
  }

  changeLoading(): void {
    this.isLoadingTable = !this.isLoadingTable;
  }

  closeSnack(): void {
    this.snackbar = false;
  }

  onInputChange() {
    this.btn_disabled = true;
    this.verifyBtnDisabled();
  }

  verifyBtnDisabled() {
    const hasValidTitle = this.title?.length >= 3;
    const hasValidAxles = this.axlesOptions.every((item) => item.axle?.length >= 3);
    const hasValidBrands = this.tyreBrands.every((item) => item.brand?.length >= 3);
    const hasValidSizes = this.tyreSizes.every((item) => item.size?.length >= 3);

    if (hasValidTitle && hasValidAxles && hasValidBrands && hasValidSizes) {
      this.btn_disabled = false;
    }
    return this.btn_disabled;
  }

  // Métodos para Eixos
  addAxleItem() {
    this.axlesOptions.push({
      id: this.nextAxleId,
      axle: "",
      fragmentAxleId: "",
    });
    this.nextAxleId++;
    this.btn_disabled = true;
  }

  removeAxleItem(id: number) {
    const index = this.axlesOptions.findIndex((item) => item.id === id);
    if (index !== -1) {
      this.axlesOptions.splice(index, 1);
      this.verifyBtnDisabled();
    }
  }

  // Métodos para Marcas de Pneu
  addTyreBrandItem() {
    this.tyreBrands.push({
      id: this.nextTyreBrandId,
      brand: "",
      fragmentBrandId: "",
    });
    this.nextTyreBrandId++;
    this.btn_disabled = true;
  }

  removeTyreBrandItem(id: number) {
    const index = this.tyreBrands.findIndex((item) => item.id === id);
    if (index !== -1) {
      this.tyreBrands.splice(index, 1);
      this.verifyBtnDisabled();
    }
  }

  // Métodos para Tamanhos de Pneu
  addTyreSizeItem() {
    this.tyreSizes.push({
      id: this.nextTyreSizeId,
      size: "",
      fragmentSizeId: "",
    });
    this.nextTyreSizeId++;
    this.btn_disabled = true;
  }

  removeTyreSizeItem(id: number) {
    const index = this.tyreSizes.findIndex((item) => item.id === id);
    if (index !== -1) {
      this.tyreSizes.splice(index, 1);
      this.verifyBtnDisabled();
    }
  }

  public updateAttributes(data: any) {
    this.title = data.title;
    this.fragmentId = data.fragmentId || "";

    // Carregar Eixos
    this.axlesOptions.splice(0, 1);
    let nextAxleId = 1;
    if (data.tyresData?.axlesOptions && Array.isArray(data.tyresData.axlesOptions)) {
      data.tyresData.axlesOptions.forEach((axle: any) => {
        this.axlesOptions.push({
          id: nextAxleId,
          axle: axle.axle,
          fragmentAxleId: axle.fragmentAxleId || "",
        });
        nextAxleId++;
      });
    }

    // Carregar Marcas
    this.tyreBrands.splice(0, 1);
    let nextBrandId = 1;
    if (data.tyresData?.tyreBrands && Array.isArray(data.tyresData.tyreBrands)) {
      data.tyresData.tyreBrands.forEach((brand: any) => {
        this.tyreBrands.push({
          id: nextBrandId,
          brand: brand.brand,
          fragmentBrandId: brand.fragmentBrandId || "",
        });
        nextBrandId++;
      });
    }

    // Carregar Tamanhos
    this.tyreSizes.splice(0, 1);
    let nextSizeId = 1;
    if (data.tyresData?.tyreSizes && Array.isArray(data.tyresData.tyreSizes)) {
      data.tyresData.tyreSizes.forEach((size: any) => {
        this.tyreSizes.push({
          id: nextSizeId,
          size: size.size,
          fragmentSizeId: size.fragmentSizeId || "",
        });
        nextSizeId++;
      });
    }
  }

  async convertToJson(): Promise<void> {
    this.verifyBtnDisabled();
    if (this.typeFragment && !this.btn_disabled) {
      try {
        const json = {
          title: this.title,
          fragmentId: this.fragmentId,
          typeFragment: this.typeFragment,
          tyresData: {
            axlesOptions: this.axlesOptions.map((item) => ({
              axle: item.axle,
              fragmentAxleId: item.fragmentAxleId,
            })),
            tyreBrands: this.tyreBrands.map((item) => ({
              brand: item.brand,
              fragmentBrandId: item.fragmentBrandId,
            })),
            tyreSizes: this.tyreSizes.map((item) => ({
              size: item.size,
              fragmentSizeId: item.fragmentSizeId,
            })),
          },
          hidden_component_id: 18, // 18 é componente TIPOS DE PNEUS
        };

        this.generatedJson = json as any;
        return this.generatedJson;
      } catch (error) {
        console.error("Erro na conversão para JSON (tyre types)", error);
      }
    }
  }

  async store(): Promise<void> {
    try {
      const jsonPromise = this.convertToJson();
      const json = await jsonPromise;
      const success_error_msg = "Dados gravados";
      const data = {
        success_error_msg: success_error_msg,
        json: json,
      };

      this.$emit("generatedJson", data);
      this.$emit("close-modal");
    } catch (error) {
      const successErrorMsg = "Erro ao tentar gravar os dados";
      console.log("Erro ao gravar os dados (tyre types)", error);
    }
  }
}
</script>

<style lang="css">
.default-data-base {
  border: solid #efecec 0.4px;
}

.w-3 {
  width: 10px;
}

.h-3 {
  height: 10px;
}

.mainInputs:not(:last-child) {
  margin-bottom: 15px;
}

.titleSt {
  margin-right: 200px;
}
</style>
